import type { NotificationsReferential } from "./referential-notifications.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_ENDPOINT } from "@/entities/referential";

import { filterNotificationByType } from "./referential-notifications.helper";

export const useReferentialNotifications = (
  options?: UseReferentialOptions<NotificationsReferential[]>
) => {
  const { data, ...result } = useReferential<NotificationsReferential[]>(
    REFERENTIAL_ENDPOINT.NOTIFICATIONS,
    options
  );

  const notifications = data ?? [];
  const moduleNotifications = filterNotificationByType(notifications, "module");
  const genericNotifications = filterNotificationByType(
    notifications,
    "generic"
  );

  return {
    notifications: notifications,
    genericNotifications,
    moduleNotifications,
    ...result,
  };
};
